export const grabAndGo = {
	searchPlaceholder: "Filtrar produtos",
	activeProducts: "Produtos ativos para Grab and Go",
	disabledProducts: "Produtos desativados para Grab and Go",
};
